import { APP_DISCOVER_KNOWN_TYPES } from '../../constants/AppDiscoverTypes.ts';
/**
 * Common Props for all app discover types
 */
export const commonAppDiscoverProps = {
    type: {
        type: String,
        required: true,
        validator: (v) => typeof v === 'string' && APP_DISCOVER_KNOWN_TYPES.includes(v),
    },
    id: {
        type: String,
        required: true,
    },
    date: {
        type: Number,
        required: false,
        default: undefined,
    },
    expiryDate: {
        type: Number,
        required: false,
        default: undefined,
    },
    headline: {
        type: Object,
        required: false,
        default: () => null,
    },
    link: {
        type: String,
        required: false,
        default: () => null,
    },
};
